import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Plus, Coins } from 'lucide-react';
import { formatNumber } from '@/lib/format';

interface SidebarHeaderProps {
  credits: { balance: number } | null;
  onNewChat: () => void;
  onCreditsClick: () => void;
}

export function SidebarHeader({ credits, onNewChat, onCreditsClick }: SidebarHeaderProps) {
  const { t } = useTranslation('dashboard');
  return (
    <div className="px-4 pt-4 pb-2">
      <div className="flex items-center justify-between mb-3">
        <NavLink to="/agents" className="flex items-center gap-2">
          {/* The lockup is artwork. The wordmark is never typeset. */}
          <img src="/img/brand/lockup_ink.png" alt="Aikka" className="h-[18px] w-auto shrink-0" />
        </NavLink>
        <button
          type="button"
          onClick={onNewChat}
          className="p-1.5 rounded-control hover:bg-secondary text-ink-2 transition-colors"
          title={t('shell.newConversation')}
          aria-label={t('shell.newConversation')}
        >
          <Plus className="h-4 w-4" />
        </button>
      </div>

      {credits && (
        <button
          type="button"
          onClick={onCreditsClick}
          className="flex items-center gap-1.5 px-2.5 py-1 rounded-control border border-hairline bg-paper transition-colors hover:bg-secondary w-fit text-xs text-ink-2"
        >
          <Coins className="h-3 w-3 text-solar-ink" strokeWidth={1.7} />
          <span className="font-semibold text-foreground">{formatNumber(credits.balance)}</span>
          <span>{t('shell.credits')}</span>
        </button>
      )}
    </div>
  );
}
